export default __webpack_public_path__ + "img/bg_record_stores-67f8806bce1442e435ff6605c0f4fda4.png";